export const SUBMIT_EMERGENCY_RELIEF_FUND =
  'app/EmergencyReliefFund/SUBMIT_EMERGENCY_RELIEF_FUND';
export const SUBMIT_EMERGENCY_RELIEF_FUND_ERROR =
  'app/EmergencyReliefFund/SUBMIT_EMERGENCY_RELIEF_FUND_ERROR';
export const SUBMIT_EMERGENCY_RELIEF_FUND_SUCCESS =
  'app/EmergencyReliefFund/SUBMIT_EMERGENCY_RELIEF_FUND_SUCCESS';
